module.exports = __webpack_public_path__ + "img/draft-white.8058a268.svg";